import { Model, Store, Casts } from 'store/Base';
import { observable } from 'mobx';
import { Project } from 'store/Project';
import { User } from 'store/User';

export class DeveloperAllocationEntry extends Model {
    static backendResourceName = 'developer_allocation_entry';

    @observable id = null;
    @observable dayOfWeek = 0;
    @observable project = this.relation(Project);
    @observable hours = 8;
}

export class DeveloperAllocationEntryStore extends Store {
    Model = DeveloperAllocationEntry;
    static backendResourceName = 'developer_allocation_entry';
}

export class DeveloperAllocation extends Model {
    static backendResourceName = 'developer_allocation';

    @observable id = null;
    @observable user = this.relation(User);
    @observable startDate = null;
    @observable endDate = null;
    @observable entries = this.relation(DeveloperAllocationEntryStore);

    casts() {
        return {
            startDate: Casts.date,
            endDate: Casts.date,
        };
    }
}

export class DeveloperAllocationStore extends Store {
    Model = DeveloperAllocation;
    static backendResourceName = 'developer_allocation';
}
